$(() => {
 // set values as selected items

 const radioList = document.querySelectorAll(".wizard-option input");
 const tabsList = document.querySelectorAll(".wizard__inner button");
 const tabOneText = $(".wizard__link__selection");
 const tabTwoText = $(".wizard__link__next");
 const nextButton = $(".first-tab-btn"); // next btn
 const previousButton = $(".prev-btn"); // second tab previous btn
 const wizardContent = $(".wizard-content__inner");

 // Set values when changes of the fields
 const selectedValue = (val) => {
  if (val) {
   tabOneText.text(val);
   nextButton.addClass("active");
   nextButton.attr("data-option", val);
  } else {
   nextButton.removeAttr("data-option");
   nextButton.removeClass("active");
  }
 };

 const activateBottomBanner = () => {
  const tabName = document.querySelector(".wizard__link.tab3");
  const bannerOne = document.querySelector(
   ".bs-section--change-certification-how-do-plastics.bs-section--map-tab-1"
  );
  const bannerTwo = document.querySelector(
   ".bs-section--change-certification-how-do-plastics.bs-section--map-tab-2"
  );
  if (tabName.classList.contains("current")) {
   bannerOne.style.display = "none";
   bannerTwo.style.display = "block";
  } else {
   bannerOne.style.display = "block";
   bannerTwo.style.display = "none";
  }
 };

 // looping all values
 for (let i = 0; i < radioList.length; i++) {
  if (i == 0) {
   let fistVal = radioList[i].value;
   if (fistVal != "") {
    radioList[i].checked = true;
    selectedValue(fistVal);
   }
  }
  radioList[i].addEventListener("change", (e) => {
   if (e.target.value) {
    selectedValue(e.target.value);
   }
  });
 }

 if (tabsList.length != 0) {
  for (let i = 0; i < tabsList.length; i++) {
   tabsList[i].addEventListener("click", (e) => {
    activeTab(i + 1);
    activateBottomBanner();
   });
  }
 }

 // activated selected tabs
 const activeTab = (tabId) => {
  if (tabId !== 0) {
   if (tabsList.length != 0) {
    for (let d = 0; d < tabsList.length; d++) {
     tabsList[d].classList.remove("current");
     tabsList[d].classList.remove("wizard__link--active");
     if (d <= tabId - 1) {
      tabsList[d].classList.add("wizard__link--active");
     } else {
      tabsList[d].classList.remove("wizard__link--active");
     }
    }

    $([document.documentElement, document.body]).animate(
     {
      scrollTop:
       $(".wizard__inner").offset().top - ($("#header").height() + 200),
     },
     700
    );
   }
   tabsList[tabId - 1].classList.add("current");
   // tab contents
   wizardContent.find(".wizard-content__tab").hide();
   wizardContent.find(".wizard-content__tab.tab" + tabId).show();
  } else {
   activeTab(1);
  }
 };

 // activate summery btn
 const activateSummeryBtn = (btn) => {
  $(btn).addClass("active");
 };

 // deactivate summery btn
 const disableSummeryBtn = (btn) => {
  $(btn).removeClass("active");
 };

 const checkActiveCheckboxes = (inputsBox, summeryBtn) => {
  if (inputsBox.length != 0) {
   let isCheck = 0;
   for (let d = 0; d < inputsBox.length; d++) {
    const element = inputsBox[d];
    if (element.checked) {
     isCheck++;
     activateSummeryBtn(summeryBtn);
    }
   }
   if (isCheck == 0) {
    disableSummeryBtn(summeryBtn);
   }
  }
 };

 // validate checkboxes and summery btn
 const validateCheckboxes = () => {
  const wizardAccordion = document.querySelectorAll("#wizard-accordion .card");
  if (wizardAccordion.length != 0) {
   for (let i = 0; i < wizardAccordion.length; i++) {
    let headerElement = $(wizardAccordion[i]).find(".card-header")[0];
    if (headerElement) {
     headerElement.addEventListener("click", (e) => {
      const elementData = e.srcElement.offsetParent;
      console.log("elementData", elementData);
      const expandVal = $(elementData).attr("aria-expanded");
      if (expandVal == "false") {
       const titleValue = $(elementData).find("h3").text();
       tabTwoText.html(titleValue);
       const summeryBtn = $(wizardAccordion[i]).find(".wizard-body__btn");
       const inputsBox = $(wizardAccordion[i]).find('[type="checkbox"]');
       checkActiveCheckboxes(inputsBox, summeryBtn);
       if (inputsBox.length != 0) {
        for (let d = 0; d < inputsBox.length; d++) {
         inputsBox[d].checked = false;
         disableSummeryBtn(summeryBtn);
         inputsBox[d].addEventListener("change", (e) => {
          checkActiveCheckboxes(inputsBox, summeryBtn);
         });
        }
       }
      } else {
       tabTwoText.html("");
      }
     });
    }
   }
  }
 };

 validateCheckboxes();

 // first next button
 nextButton.on("click", (e) => {
  if (e.target.classList.contains("active")) {
   let supplyChainId = $('input[name="chain_response"]:checked').data("postid");
   getChangesItems(supplyChainId);
  }
 });

 // second tab previous button
 previousButton.on("click", (e) => {
  // active second tab
  activeTab(1);
 });

 // last tab back btn
 $(".wizard-tab-three").on("click", ".third-previous", (e) => {
  activeTab(2);
  activateBottomBanner();
 });

 $("#wizard-accordion").on("click", ".wizard-body__btn", (e) => {
  let btn = $(e.target);
  let identifier = e.target.getAttribute("data-identifier");
  let supplyChainId = $("#supply-chain-id").val();
  let changeListItemId = $(`#${identifier}`).val();
  let selectedChangeItems = [];
  $(`.${identifier}`).each((index, ele) => {
   let $this = $(ele);
   if ($this.is(":checked")) {
    selectedChangeItems.push($this.val());
   }
  });
  let args = {
   supply_chain_id: supplyChainId,
   change_list_item_id: changeListItemId,
   change_items_ids: selectedChangeItems,
  };
  getTasksList(args);
 });

 const getChangesItems = (supplyChainId) => {
  $.ajax({
   url: e25_ajax.ajax_url,
   type: "post",
   data: {
    action: "get_changes_list",
    ajax: true,
    nonce: e25_ajax.nonce,
    supply_chain_id: supplyChainId,
   },
   dataType: "json",
   beforeSend: () => {
    nextButton.removeClass("active");
   },
   success: (response) => {
    if (response) {
     if (response.success == true) {
      nextButton.addClass("active");
      $("#wizard-accordion").empty().html(response.data.html);
      // active second tab
      activeTab(2);
      validateCheckboxes();
     }
    }
   },
   error: (errorThrown) => {
    console.log(errorThrown.responseJSON);
    nextButton.addClass("active");
   },
  });
 };

 const getTasksList = (data) => {
  $.ajax({
   url: e25_ajax.ajax_url,
   type: "post",
   data: {
    action: "get_task_summary_items",
    ajax: true,
    nonce: e25_ajax.nonce,
    data: data,
   },
   dataType: "json",
   beforeSend: () => {},
   success: (response) => {
    if (response) {
     if (response.success == true) {
      $(".wizard-tab-three").empty().html(response.data.html);
      // active third tab
      activeTab(3);
      activateBottomBanner();
     }
    }
   },
   error: (errorThrown) => {
    console.log(errorThrown.responseJSON);
   },
  });
 };
});
